// Detect Chrome.
(function() {
  if (/Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)) {
    var DHtml = document.getElementsByTagName('html')[0];
    var _className = DHtml.getAttribute('class');
    DHtml.setAttribute('class', _className + ' CHROME');
  }
  if (navigator.userAgent.match('CriOS')) {
    var DHtml = document.getElementsByTagName('html')[0];
    var _className = DHtml.getAttribute('class');
    DHtml.setAttribute('class', _className + ' CriOS');
  }
})();


//////////////////
// WEBPACK FOOTER
// ./src/app/utilities/detect-chrome.js
// module id = 1344
// module chunks = 22